import { render, staticRenderFns } from "./statusItem.vue?vue&type=template&id=bf6492b2&scoped=true&"
import script from "./statusItem.vue?vue&type=script&lang=js&"
export * from "./statusItem.vue?vue&type=script&lang=js&"
import style0 from "./statusItem.vue?vue&type=style&index=0&id=bf6492b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6492b2",
  null
  
)

export default component.exports